import {
  CREATE_ROLE,
  CREATE_ROLE_FAILED,
  CREATE_ROLE_SUCCESS,
  DELETE_ROLE,
  DELETE_ROLE_FAILED,
  DELETE_ROLE_SUCCESS,
  GET_ADMIN_ROLES,
  GET_ADMIN_ROLES_FAILED,
  GET_ADMIN_ROLES_SUCCESS,
  GET_ROLE,
  GET_ROLE_FAILED,
  GET_ROLE_SUCCESS,
  HIDE_ADMIN_ROLE_MODAL,
  HIDE_DELETE_ROLE_MODAL,
  OPEN_ADMIN_ROLE_MODAL,
  OPEN_DELETE_ROLE_MODAL,
  RESET_ROLE,
  UPDATE_ROLE,
  UPDATE_ROLE_FAILED,
  UPDATE_ROLE_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  loading: false,
  error: "",
  adminRoles: [],
  adminRoleModalIsOpen: false,
  selectedRole: null,
  deleteRoleModalIsOpen: false,
}

const Roles = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ADMIN_ROLES:
    case GET_ROLE:
    case CREATE_ROLE:
    case UPDATE_ROLE:
    case DELETE_ROLE:
      return {
        ...state,
        loading: true,
      }
    case GET_ADMIN_ROLES_FAILED:
    case GET_ROLE_FAILED:
    case CREATE_ROLE_FAILED:
    case UPDATE_ROLE_FAILED:
    case DELETE_ROLE_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case GET_ADMIN_ROLES_SUCCESS:
      return {
        ...state,
        adminRoles: action.payload,
        loading: false,
      }
    case OPEN_ADMIN_ROLE_MODAL:
      return {
        ...state,
        adminRoleModalIsOpen: true,
      }
    case HIDE_ADMIN_ROLE_MODAL:
      return {
        ...state,
        adminRoleModalIsOpen: false,
      }
    case GET_ROLE_SUCCESS:
      return {
        ...state,
        selectedRole: action.payload,
        loading: false,
      }
    case RESET_ROLE:
      return {
        ...state,
        selectedRole: null,
      }
    case CREATE_ROLE_SUCCESS:
      return {
        ...state,
        adminRoles: [...state.adminRoles, action.payload],
        loading: false,
      }
    case UPDATE_ROLE_SUCCESS:
      return {
        ...state,
        adminRoles: state.adminRoles?.map(role =>
          role?.id === action?.payload?.id ? action?.payload : role
        ),
        loading: false,
      }
    case OPEN_DELETE_ROLE_MODAL:
      return {
        ...state,
        deleteRoleModalIsOpen: true,
      }
    case HIDE_DELETE_ROLE_MODAL:
      return {
        ...state,
        deleteRoleModalIsOpen: false,
      }
    case DELETE_ROLE_SUCCESS:
      return {
        ...state,
        adminRoles: state.adminRoles?.filter(
          role => role?.id !== action?.payload
        ),
        loading: false,
      }
    default:
      return state
  }
}

export default Roles
